import type { ReactNode } from "react";
import { LazyMotion, MotionConfig, domAnimation } from "framer-motion";
import PublicFooter from "@/components/public/PublicFooter";
import PublicNav, { type PublicNavSection } from "@/components/public/PublicNav";

type MarketingLayoutProps = {
  active: PublicNavSection;
  children: ReactNode;
};

/**
 * Shared shell for the public marketing pages: dark surface, fixed nav, footer,
 * and the motion providers every section relies on.
 *
 * `LazyMotion` is not optional — the sections animate with framer-motion's `m`
 * components, which carry no animation features on their own. Without it they
 * keep their `initial` opacity forever and the page renders blank.
 */
export default function MarketingLayout({ active, children }: MarketingLayoutProps) {
  return (
    <LazyMotion features={domAnimation} strict>
      <MotionConfig reducedMotion="user">
        <div className="dark min-h-screen overflow-x-clip bg-ios text-ios selection:bg-[rgb(var(--ios-accent)/0.3)]">
          <PublicNav active={active} />
          <main id="top">{children}</main>
          <PublicFooter />
        </div>
      </MotionConfig>
    </LazyMotion>
  );
}
